const PaymentMethodEnum = {
  CASH: 1,
  CREDIT_CARD: 2,
  BANK_TRANSFER: 3,
  CHECK: 4,
  OTHER: 5,
  DEPOSIT_ACCOUNT: 6,
};

export default PaymentMethodEnum;
